var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDlPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dl"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "218.87 66.44 202.69 9.89 71.17 27.19 37.13 65.14 80.84 62.16",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "72.47 64.58 96.28 57.88 122.33 62.72 137.21 63.84",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "113.96 60.67 186.13 56.58 202.69 9.89",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.45 42.82 116.37 39.47 136.09 23.84 102.42 27.38 83.45 42.82",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "178.88 57.7 178.88 99.27 212.92 96.34 212.92 65.14 218.13 65.14",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.9,
    y1: 18.45,
    x2: 212.92,
    y2: 65.14,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "178.88 99.27 134.7 97.79 120.75 100.11 43.45 94.72 43.45 64.95",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "77.36 96.34 77.36 67.88 119.91 66.49 134.56 67.6 134.56 97.32",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "120.75 100.11 120.75 66.49 120.75 63.28",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.36,
    y1: 67.88,
    x2: 77.36,
    y2: 64.25,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.56,
    y1: 67.6,
    x2: 134.56,
    y2: 63.98,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.72,
    y: 66.91,
    width: 9.63,
    height: 17.58,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.72,
    y: 66.91,
    width: 9.63,
    height: 17.58,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.2,
    y: 70.22,
    width: 6.98,
    height: 14.27,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.24,
    y: 70.22,
    width: 6.98,
    height: 14.27,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.56,
    y1: 97.74,
    x2: 92.56,
    y2: 67.74,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.86,
    y1: 66.91,
    x2: 103.86,
    y2: 99.13,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "103.86 86.76 120.33 87.41 134.7 85.88",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.91,
    y1: 85.74,
    x2: 92.29,
    y2: 86.31,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "85.87 42.35 85.87 51.28 116.7 49.74 130.93 28.4",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.28,
    y1: 85.74,
    x2: 86.28,
    y2: 68.02,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.68,
    y1: 85.74,
    x2: 81.68,
    y2: 67.88,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.3,
    y1: 86.72,
    x2: 109.3,
    y2: 67.32,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.75,
    y1: 87.41,
    x2: 114.75,
    y2: 67.6,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.79,
    y1: 86.3,
    x2: 124.79,
    y2: 67.18,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.51,
    y1: 86.3,
    x2: 130.51,
    y2: 67.6,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.82
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.28 44.64 88.52 45 88.52 50.3 92.28 49.94 92.28 44.64",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.46
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.96 44.22 96.19 44.58 96.19 49.88 99.96 49.52 99.96 44.22",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.46
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.63 43.8 103.86 44.16 103.86 49.47 107.63 49.1 107.63 43.8",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.46
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.96 43.28 111.19 43.65 111.19 48.95 114.96 48.59 114.96 43.28",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.7,
    y1: 49.74,
    x2: 116.7,
    y2: 39.14,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.46
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "77.22 71.93 92.7 71.93 104 71.74",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.49,
    y1: 81,
    x2: 92.14,
    y2: 81,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.46
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "104.14 71.23 120.61 71.23 134.42 71.65",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.46
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "104.14 82.67 120.47 82.67 134.28 81.83",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.46
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.29 38.72 193.29 37.05 193.29 50.54 197.29 51.47 197.29 38.72",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.46
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.25 40.49 199.25 38.82 199.25 52.3 203.25 53.23 203.25 40.49",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.46
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.25 46.07 205.2 45.51 205.2 51.74 207.34 52.3 207.25 46.07",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.46
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "197.11 26.91 198.97 28.12 198.97 22.91",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.46
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlPop);
export default __webpack_public_path__ + "static/media/dl_pop.cd1a70c677abd3b8a03b4ca3eb837edd.svg";
export { ForwardRef as ReactComponent };